import { Error } from "@components/Error";
import { Loader } from "@components/Loader";
import { SearchBarILS } from "@components/SearchBar";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Container, Grid } from "semantic-ui-react";
import { ItemsResultsList } from "./ItemsResultsList";
import { CheckoutModal } from "../ItemsCheckout/CheckoutModal";
import _isEmpty from "lodash/isEmpty";

export default class ItemsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevSearchQuery: "",
      executedSearch: false,
      showCheckoutModal: false,
      selectedItem: null,
    };
    this.searchBarRef = React.createRef();
  }

  componentWillUnmount = () => {
    const { clearResults } = this.props;
    clearResults();
  };

  openCheckoutModal = (item) => {
    this.setState({
      showCheckoutModal: true,
      selectedItem: item,
    });
  };

  closeCheckoutModal = () => {
    this.setState({
      showCheckoutModal: false,
      selectedItem: null,
    });
  };

  handleCheckoutConfirm = (item, force = false) => {
    const { checkoutItem, patronDetails } = this.props;
    if (checkoutItem) {
      checkoutItem(
        item.document_pid,
        item.item_pid,
        patronDetails.user_pid,
        force
      );
    }
    this.closeCheckoutModal();
  };

  executeSearch = async (queryString, patronPid) => {
    const {
      queryString: propsQueryString,
      patronDetails,
      fetchAndCheckoutIfOne,
    } = this.props;

    queryString = queryString || propsQueryString;
    patronPid = patronPid || patronDetails.user_pid;

    this.setState({ prevSearchQuery: queryString, executedSearch: true }, () =>
      fetchAndCheckoutIfOne(
        queryString,
        patronPid,
        this.searchBarRef.current.clearQueryString
      )
    );
  };

  onPasteHandler = async (event) => {
    const { prevSearchQuery } = this.state;
    const { patronDetails } = this.props;

    event.preventDefault();

    let queryString = event.clipboardData.getData("Text");

    const sameQueryString = prevSearchQuery === queryString;

    if (queryString && !sameQueryString) {
      await this.executeSearch(queryString, patronDetails.user_pid);
    }
  };

  renderResultsList = (results) => {
    const {
      patronDetails,
      clearResults,
      isLoadingSearch,
      patronData,
      borrowingStats,
      currentLoans,
      checkoutItem,
    } = this.props;
    const { executedSearch } = this.state;
    return (
      <ItemsResultsList
        patronPid={patronDetails.user_pid}
        clearResults={clearResults}
        results={results}
        isLoading={isLoadingSearch}
        executedSearch={executedSearch}
        patronData={patronData}
        borrowingStats={borrowingStats}
        currentLoans={currentLoans}
        checkoutItem={checkoutItem}
        onCheckout={this.openCheckoutModal}
      />
    );
  };

  render() {
    const {
      items,
      isLoading,
      error,
      queryString,
      patronData,
      borrowingStats,
      currentLoans,
    } = this.props;
    const { showCheckoutModal, selectedItem } = this.state;

    return (
      <>
        <Container className="spaced">
          <SearchBarILS
            onSearchHandler={this.executeSearch}
            placeholder="Type or paste to search for physical copies..."
            onPasteHandler={this.onPasteHandler}
            ref={this.searchBarRef}
          />
        </Container>
        <Grid columns={1} stackable relaxed>
          <Grid.Column width={16}>
            <Loader isLoading={isLoading}>
              <Error error={error}>
                {_isEmpty(queryString) && _isEmpty(items)
                  ? null
                  : this.renderResultsList(items)}
              </Error>
            </Loader>
          </Grid.Column>
        </Grid>

        {showCheckoutModal && selectedItem && (
          <CheckoutModal
            open={showCheckoutModal}
            onClose={this.closeCheckoutModal}
            onCheckout={this.handleCheckoutConfirm}
            item={selectedItem}
            patronData={patronData}
            borrowingStats={borrowingStats}
            currentLoans={currentLoans}
          />
        )}
      </>
    );
  }
}

ItemsSearch.propTypes = {
  fetchAndCheckoutIfOne: PropTypes.func.isRequired,
  clearResults: PropTypes.func.isRequired,
  checkoutItem: PropTypes.func,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingSearch: PropTypes.bool,
  items: PropTypes.object,
  patronData: PropTypes.object,
  borrowingStats: PropTypes.object,
  currentLoans: PropTypes.object,
  patronDetails: PropTypes.object.isRequired,
  queryString: PropTypes.string.isRequired,
};

ItemsSearch.defaultProps = {
  error: null,
  isLoading: false,
  isLoadingSearch: false,
  items: null,
  checkoutItem: null,
};
